<template>
  <el-dialog
    :title="addDiaInfo.title"
    :visible.sync="addDiaInfo.show"
    v-if="addDiaInfo.show"
    width="800px"
  >
    <div class="big-class-name">
      {{ className
      }}<span v-if="smallClassNum == 0">  (首次新增至少增加两个小班)</span>
    </div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="70px"
      size="small"
    >
      <el-form-item label="小班简称:" prop="name">
        <div v-for="(item, index) in childName" :key="index" class="name-item">
          <el-input
            v-model="childName[index]"
            placeholder="请输入小班简称"
            class="input-item"
            maxlength="15"
          ></el-input>
          <i
            class="el-icon-circle-plus-outline edit-icon"
            @click="add(index)"
          ></i>
          <i class="el-icon-remove-outline edit-icon" @click="del(index)"></i>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click.native="cancel" title="取消"></butn>
      <butn btntype="primary" @click.native="confirm" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";

export default {
  components: { butn },
  props: {
    addDiaInfo: {
      type: Object,
      default: () => {
        return {
          show: false,
          title: "新增班级",
        };
      },
    },
    smallClassNum: {
      type: Number,
      default: () => 0,
    },
    className: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {
      childName: [],
      ruleForm: {
        name: "666",
      }, //
      rules: {
        name: [{ required: true, message: "", trigger: "blur" }],
      }, //
      isInit: false, //
    };
  },
  created() {
    if (this.smallClassNum === 0) {
      this.childName.splice(0, 0, "", "");
      this.isInit = true;
    } else {
      this.childName.splice(0, 0, "");
    }
  },
  methods: {
    add(index) {
      if (this.smallClassNum + this.childName.length === 10) {
        this.$message.warning("最多建立10个小班!");
      } else {
        this.childName.splice(index + 1, 0, "");
      }
    },
    del(index) {
      let len = this.childName.length;
      if (this.isInit && len <= 2) {
        this.$message.warning("首次新增至少创建2个小班!");
      } else if (this.childName.length === 1) {
        this.$message.warning("至少创建1个小班!");
      } else {
        this.childName.splice(index, 1);
      }
    },
    cancel() {
      this.$emit("closeDia");
    },
    confirm() {
      let flag = this.childName.some((x) => {
        return x === "" || x === null;
      });
      if (flag) {
        this.$message.warning("小班简称不能为空");
      } else {
        this.$emit("addSmallClass", this.childName);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.big-class-name {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 15px;
}
.name-item {
  margin: 0 0 10px 10px;
}
.input-item {
  width: 300px;
  margin-right: 10px;
}
.edit-icon {
  font-size: 20px;
  margin-right: 10px;
  cursor: pointer;
}
</style>
